export default __webpack_public_path__ + "static/media/StudentLoanDebt.f96a6e16.png";